export const painPoints = [
  {
    emoji: '🧭',
    title: 'Du weißt nicht, wo du anfangen sollst',
    desc: 'Das koreanische Alphabet wirkt unmöglich und du bist überfordert, wo du beginnen sollst. Diese Methode organisiert alles: Erst die Grundlagen, dann die Praxis, dann das Gesprächliche.',
  },
  {
    emoji: '🔤',
    title: 'Du blockierst beim Hangeul (und alles klingt gleich)',
    desc: 'Du lernst es hier geführt, sodass du Muster erkennst und bewusst aussprichst. Keine Verwirrung mehr zwischen ähnlichen Buchstaben und Lauten.',
  },
  {
    emoji: '🧩',
    title: 'Du kennst zufällige Wörter, aber kannst keine Sätze bilden',
    desc: 'Du lernst die Grundstruktur von Sätzen, um Sätze zu bauen, die echten Sinn ergeben, und ab Tag eins zu kommunizieren.',
  },
  {
    emoji: '💭',
    title: 'Du studierst, aber vergisst schnell',
    desc: 'Du erhältst konkrete Tipps zum Merken und Aufbewahrungsroutinen, damit das, was du studierst, in deinem Gehirn bleibt.',
  },
  {
    emoji: '🎬',
    title: 'Du siehst K-Dramen und verstehst nichts',
    desc: 'Die Untertitel machen die ganze Arbeit und du verpasst kein einziges echtes Wort. Hier trainierst du dein Ohr mit Ausdrücken, die wirklich auf dem Bildschirm erscheinen.',
  },
  {
    emoji: '🔁',
    title: 'Du hast eine App begonnen und nach zwei Wochen aufgehört',
    desc: 'Serien sind kein Fortschritt. Ein täglicher 60-Minuten-Plan mit sichtbaren Schritten ist das, was dich voranbringt.',
  },
];
